// Delegate the installed Core API, including future exports, without copying its requests.
export * from '../../../node_modules/@eliadmin/core/src/api/general/general-api';
import { fetchMenu as fetchCoreMenu } from '../../../node_modules/@eliadmin/core/src/api/general/general-api';
import { env } from '@eliadmin/core/src/env';

function isEmptyInformationPage(path?: string) {
  if (!path) return false;
  try {
    const url = new URL(path, 'https://najtrvalky.sk/');
    return (
      url.origin === 'https://najtrvalky.sk' &&
      ['/o-nas', '/blog'].includes(url.pathname.replace(/\/$/, ''))
    );
  } catch {
    return false;
  }
}

// These two published SK pages are empty. Hide only their footer entries; retain CMS data.
export const fetchMenu: typeof fetchCoreMenu = async req => {
  const response = await fetchCoreMenu(req);
  if (env.NEXT_PUBLIC_CURRENT_STORE !== 'najtrvalky.sk' || req.locale !== 'sk')
    return response;
  let changed = false;
  const data = response.data?.map(menu => {
    if (menu.main_type !== 'footer' || !menu.fields?.some(field => isEmptyInformationPage(field.path)))
      return menu;
    changed = true;
    return { ...menu, fields: menu.fields.filter(field => !isEmptyInformationPage(field.path)) };
  });
  return changed ? { ...response, data } : response;
};
